import React from 'react';

export function ARViewer() {
  return (
    <iframe
      title="AR Viewer"
      src="https://nacimsereir.8thwall.app/anahome/"
      allow="camera; microphone; fullscreen; xr-spatial-tracking"
      allowfullscreen
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
}

export default ARViewer;